import { Trans } from '@lingui/macro';
import _ from 'lodash';

import FixedLabelContainer, { Row, Label, Content, Line } from '../../fixed-label-container/FixedLabelContainer';

import StatusBreakoutRow from '../../status-breakout/StatusBreakoutRow';
import StatusBreakout from '../../charts/status-breakout/StatusBreakout';
import { convertStatusToStatusCounts } from '../../charts/data-series';
import usePanelDataService from '../../../services/PanelDataService';
import { useSite } from '../../filters';

const dataSource = {
    url: '/query/table',
    params: {
        type: 'site',
        metrics: [
            'status',
            'siteDeviceStatus',
            'siteServerStatus',
            'testStatus',
            'networkStatus',
            'siteTestCounts',
            'siteWorstTestCounts',
            'siteServerCounts',
            'siteDeviceCounts',
            'siteWanCounts',
            'siteTestCounts',
            'apCounts',
        ],
        renderAsEntity: 'true',
        trends: [
            'siteDeviceCounts',
            'siteServerCounts',
            'testStatus',
            'siteWanCounts',
            'status',
            'siteTestCounts',
            'siteWorstTestCounts',
            'apCounts',
        ],
    },
};

const present = (data, metric) => {
    const counts = data?.[metric];
    return counts?.total;
};

const WAN_INTERFACE_FILTER = [
    {
        name: 'InterfaceType',
        uuid: 'wan',
    },
];

const empty = { trends: { status: { data: [] } } };

export default function SiteDetail({ onTimeRangeChange = _.noop }) {
    const site = useSite();
    const statusCounts = usePanelDataService(dataSource);
    const statusData = statusCounts?.data?.[0];
    const overAllCounts = statusData ? convertStatusToStatusCounts('status', statusData) : empty;
    const clearTimeRange = statusData === undefined;
    const height = clearTimeRange ? 30 : 20;
    let last = '';
    if (present(statusData, 'siteDeviceCounts')) last = 'siteDeviceCounts';
    else if (present(statusData, 'siteServerCounts')) last = 'siteServerCounts';
    else if (present(statusData, 'siteWanCounts')) last = 'siteWanCounts';
    else if (present(statusData, 'siteTestCounts')) last = 'siteTestCounts';

    if (!site || !statusCounts) return null;

    return (
        <FixedLabelContainer>
            <Row>
                <Label>
                    <Trans>Overall Status</Trans>
                </Label>
                <Content>
                    <StatusBreakout
                        height={height}
                        disableTimeAxis
                        metricName="status"
                        data={overAllCounts}
                        onTimeRangeChange={onTimeRangeChange}
                        clearTimeRange={clearTimeRange}
                        isStatus
                    />
                </Content>
            </Row>
            <Line />
            <StatusBreakoutRow
                page="/tests"
                title={<Trans>Service Tests</Trans>}
                metric="siteTestCounts"
                data={statusData}
                last={last}
                entityType="site"
                entityUuid={site?.uuid}
            />
            <StatusBreakoutRow
                page="/interfaces"
                title={<Trans>WAN Interfaces</Trans>}
                metric="siteWanCounts"
                data={statusData}
                last={last}
                filters={WAN_INTERFACE_FILTER}
                entityType="site"
                entityUuid={site?.uuid}
            />
            <StatusBreakoutRow
                page="/servers"
                title={<Trans>Servers</Trans>}
                metric="siteServerCounts"
                data={statusData}
                last={last}
                entityType="site"
                entityUuid={site?.uuid}
            />
            <StatusBreakoutRow
                page="/network-devices"
                title={<Trans>Network Devices</Trans>}
                metric="siteDeviceCounts"
                data={statusData}
                last={last}
                entityType="site"
                entityUuid={site?.uuid}
            />
        </FixedLabelContainer>
    );
}
